import React from 'react'
import {
  View,
  FlatList,
  Platform,
  Dimensions,
  TouchableOpacity
} from 'react-native'
import PropTypes from 'prop-types'
import moment from 'moment'
import { SafeAreaView } from 'react-native-safe-area-context'

import { Icon, VFScreen } from '@vfgroup-oneplatform/foundation/Components'
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VfText from '../../Components/VfText'

import { getThemeImages } from '../../Themes/Modes'

import styles from './CallMeBackHistory.Styles'

import { useSafeAreaInsets } from 'react-native-safe-area-context'
import images from '../../Themes/Images'




function CallMeBackHistory({
  onClose,
  goBack,
  historyData,
  validityObject,
  theme,
}) {

  const themeImages = getThemeImages(theme.name)
  const insets = useSafeAreaInsets()

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      // <SafeAreaView
      //   style={styles.container}
      //   // edges={['right', 'left', 'bottom']}
      // >
      <>
        <View style={styles.headerContentWrapper(insets.top)}>
          <View style={{ flex: 0.55, justifyContent: 'space-between', flexDirection: 'row' }}>
            <TouchableOpacity onPress={goBack} disabled={!onClose}>
              <Icon
                name={images.back}
                type="image"
                resizeMode="contain"
                size={24}
              />
            </TouchableOpacity>
            <VfText i18nKey="call_me_back_title" size="h4" align="center" />
          </View>
        </View>
        <View style={{ paddingHorizontal: '10%' }}>
          <FlatList
            keyExtractor={item => item.id}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={styles.flatlistContainer}
            data={historyData || []}
            ListHeaderComponent={() => (
              <View style={styles.flatlistHeaderContainer}>
                <VfText
                  i18nKey="call_me_back_history_header"
                  size="h2"
                  weight="bold"
                  style={styles.flatlistHeaderTitle}
                  color={theme.colors.textColor}
                />
                <VfText
                  i18nKey={validityObject?.['remainingpermonth']?.description}
                  size="body"
                  color={theme.colors.textColorTwo}
                />
              </View>
            )}
            renderItem={({ item }) => (<View style={styles.itemContainer}>
              <Icon
                name={images.smsText}
                size={40}
                type="image"
                resizeMode="contain"
              />
              <View style={styles.itemInfoContainer}>
                <VfText
                  i18nKey={item?.phoneNumber}
                  color={theme.colors.textColor}
                  size="h5"
                />
                <View style={styles.itemDateTimeContainer}>
                  <VfText
                    i18nKey={moment(item?.created?.value, 'DD/MM/YYYY hh:mm').format('hh:mm A')}
                    color={theme.colors.textColorTwo}
                    weight="light"
                  />
                  <VfText
                    i18nKey={moment(item?.created?.value, 'DD/MM/YYYY hh:mm').format('DD.MM.YYYY')}
                    color={theme.colors.textColorTwo}
                    weight="light"
                  />
                </View>
              </View>
            </View>)}
            ListEmptyComponent={<View style={styles.listEmptyContainer}>
              <Icon
                name={images.sms_light}
                size={200}
                type="image"
                resizeMode="contain"
              />
              <VfText
                i18nKey="call_me_back_history_empty_text"
                size="body"
                color={theme.colors.textColorTwo}
                style={styles.listEmptyText}
              />
            </View>}
          />
        </View>
      </>
      // </SafeAreaView>
    )
  }


  return (
    <VFScreen
      title="call_me_back_title"
      onClose={onClose}
      showBack
      onBack={goBack}
    >
      <SafeAreaView
        style={styles.container}
        edges={['right', 'left', 'bottom']}
      >
        <FlatList
          keyExtractor={item => item.id}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={styles.flatlistContainer}
          data={historyData || []}
          ListHeaderComponent={() => (
            <View style={styles.flatlistHeaderContainer}>
              <VfText
                i18nKey="call_me_back_history_header"
                size="h2"
                weight="bold"
                style={styles.flatlistHeaderTitle}
                color={theme.colors.textColor}
              />
              <VfText
                i18nKey={validityObject?.['remainingpermonth']?.description}
                size="body"
                color={theme.colors.textColorTwo}
              />
            </View>
          )}
          renderItem={({ item }) => (<View style={styles.itemContainer(theme)}>
            <Icon
              name={themeImages.smsText}
              size={40}
              type="image"
              resizeMode="contain"
            />
            <View style={styles.itemInfoContainer}>
              <VfText
                i18nKey={item?.phoneNumber}
                color={theme.colors.textColor}
                size="h5"
              />
              <View style={styles.itemDateTimeContainer}>
                <VfText
                  i18nKey={moment(item?.created?.value, 'DD/MM/YYYY hh:mm').format('hh:mm A')}
                  color={theme.colors.textColorTwo}
                  weight="light"
                />
                <VfText
                  i18nKey={moment(item?.created?.value, 'DD/MM/YYYY hh:mm').format('DD.MM.YYYY')}
                  color={theme.colors.textColorTwo}
                  weight="light"
                />
              </View>
            </View>
          </View>)}
          ListEmptyComponent={<View style={styles.listEmptyContainer}>
            <Icon
              name={themeImages.emptyList}
              size={200}
              type="image"
              resizeMode="contain"
            />
            <VfText
              i18nKey="call_me_back_history_empty_text"
              size="body"
              color={theme.colors.textColorTwo}
              style={styles.listEmptyText}
            />
          </View>}
        />
      </SafeAreaView>
    </VFScreen>
  )
}

CallMeBackHistory.defaultProps = {
  theme: {
    name: 'light',
    colors: LightThemeColors,
  }
}

CallMeBackHistory.propTypes = {
  onClose: PropTypes.func,
  goBack: PropTypes.func,
  isContentLoading: PropTypes.bool,
  historyData: PropTypes.array,
  getCallMeBackHistory: PropTypes.func,
  validityObject: PropTypes.object,
  theme: PropTypes.object,
}


export default withTheme(CallMeBackHistory)
